module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1029-bad514a252d9b1e8c3a4108140d6a0ee.png";